import { ChevronRight } from 'lucide-react'
import { Link } from 'react-router-dom'

import { paths } from 'src/config/paths'
import { ProfilePhotoFallback } from 'src/shared/features/users/components/profile-photos/profile-avatar'
import { professionMap } from 'src/shared/features/users/schemas/profession'
import type { PublicUserData } from 'src/shared/features/users/schemas/user'

import useSearchMenuActiveStore from '../store/search-menu-active-store'

type UserSearchResultItemProps = {
  user: PublicUserData
}

const UserSearchResultItem = ({ user }: UserSearchResultItemProps) => {
  const { setIsFocused } = useSearchMenuActiveStore()

  const onClick = () => {
    setIsFocused(false)
  }

  return (
    <Link onClick={onClick} to={paths.users.profile.getHref(user.username)} state={{ from: 'search' }}>
      <div className="group/user-search-card flex w-full cursor-pointer flex-row items-center justify-between gap-3">
        <div className="flex flex-row items-center gap-2">
          <div className="flex flex-row items-center gap-2">
            <div
              className="size-[40px] max-h-[40px] min-h-[40px] min-w-[40px] max-w-[40px] rounded-full border-[3px] border-white bg-white"
              style={{
                boxShadow: '0px 1px 10px 0px rgba(27,48,41,0.10)',
              }}
            >
              <img
                src={user.profilePhoto || ProfilePhotoFallback}
                alt={user.fullName}
                className="size-full rounded-full"
              />
            </div>

            <div className="flex flex-col">
              <p className="line-clamp-1 text-sm font-medium">
                <span className="font-semibold">
                  {user.firstName} {user.lastName}
                </span>
                <span className="text-muted"> &#xB7; @{user.username}</span>
              </p>
              <p className="text-xs text-muted">{professionMap[user.profession]?.label || ''}</p>
            </div>
          </div>
        </div>
        <ChevronRight size={16} />
      </div>
    </Link>
  )
}

export default UserSearchResultItem
